export const routes = {
  loginPage: '/',
  mainApp: '/app',
  learn: '/app/learning',
  stats: '/app/stats',
  aboutTeam: '/app/about-team',
  promo: '/app/promo',
  dictionary: '/app/dictionary',
  dictionaryLearn: '/app/dictionary/learn',
  dictionaryHard: '/app/dictionary/hard',
  dictionaryDeleted: '/app/dictionary/deleted',
  dictionaryForNextTrain: '/app/dictionary/next',
  speakIt: '/app/speakit',
  savanna: '/app/savanna',
  sprint: '/app/sprint',
  audioCall: '/app/audioCall',
  quiz: '/app/quiz',
  englishPuzzle: '/app/englishPuzzle',
};
